import React from "react";

function Footer() {
    return (
        <footer className="bg-gray-900 text-white py-6 font-inter relative bottom-0 w-full">
            <div className="max-w-6xl mx-auto px-4 flex flex-col items-center gap-2 text-center">
                <p className="text-sm sm:text-base">
                    © {new Date().getFullYear()} Machine Repairs Ltd | All Rights Reserved
                </p>
                <p className="text-xs sm:text-sm text-gray-300">
                    Email: <a href="mailto:machinerepairsltd@outlook.com">machinerepairsltd@outlook.com</a>
                </p>
                <p className="text-xs sm:text-sm text-gray-300">
                    Company registered in England - No. 16872212
                </p>

                <a
                    className="text-[10px] sm:text-xs text-gray-400 hover:text-white mt-2"
                    href="https://eureka-technologies.co.uk"
                >
                    Powered by Eureka Technologies Limited
                </a>
            </div>
        </footer>
    );
}

export default Footer;